var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStreams(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.24 9.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.23,6.81c-.88,0-1.76,0-2.64,0-.06,0-.11,0-.17-.01-.13-.05-.21-.19-.21-.41,0-.24,.09-.37,.23-.4,.04,0,.09,0,.14,0,1.76,0,3.52,0,5.29,0,.05,0,.09,0,.14,0,.14,.03,.23,.17,.23,.4,0,.22-.08,.36-.21,.41-.05,.02-.11,.01-.17,.01-.88,0-1.75,0-2.63,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.22,1.85c-.89,0-1.78,0-2.67,0-.09,0-.22-.08-.28-.19-.12-.21-.02-.56,.16-.62,.05-.02,.11-.01,.17-.01,1.76,0,3.52,0,5.28,0,.02,0,.03,0,.05,0,.2,0,.32,.16,.32,.42,0,.26-.12,.42-.31,.42-.9,0-1.81,0-2.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75,9.27c-.74,0-1.49,0-2.23,0-.11,0-.21-.04-.25-.27-.04-.22,.01-.46,.13-.53,.05-.03,.11-.03,.17-.03,1.45,0,2.91,0,4.36,0,.02,0,.05,0,.07,0,.15,.01,.25,.17,.25,.42,0,.25-.09,.41-.25,.41-.75,0-1.5,0-2.24,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.23,4.33c-.87,0-1.74,0-2.61,0-.06,0-.11,0-.17,0-.14-.02-.23-.16-.23-.4,0-.24,.08-.38,.23-.41,.04,0,.09,0,.14,0,1.76,0,3.53,0,5.29,0,.05,0,.1,0,.15,0,.14,.03,.21,.18,.22,.4,0,.22-.07,.37-.21,.41-.06,.01-.11,.01-.17,.01-.88,0-1.75,0-2.63,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.04,9.53c-2.7,.49-5.35,.48-8.04,0,.11-.4,.19-.79,.31-1.17,.36-1.11,.93-2.08,1.89-2.78,.16-.12,.3-.15,.5-.06,.88,.38,1.77,.38,2.64,0,.18-.08,.3-.06,.45,.05,1.06,.76,1.65,1.83,2.02,3.05,.09,.29,.14,.59,.22,.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5,2.49c0,1.38-1.07,2.42-2.48,2.42-1.39,0-2.48-1.08-2.48-2.43C1.56,1.11,2.67,0,4.04,0c1.37,0,2.47,1.11,2.47,2.49Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreams);
export default __webpack_public_path__ + "static/media/streams.2b50f22565ddd6bd72eb0b5125f5be3e.svg";
export { ForwardRef as ReactComponent };